"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoneInfo = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Header = styled_components_1.default.h3 `
  font-family: CatV, sans-serif;
  text-align: center;
`;
const Container = styled_components_1.default.div `
  position: absolute;
  right: 0;
  top: 0;
  padding: 8px;
  margin: 8px;
  background-color: white;
  border: 1px black solid;
  font-size: 14px;
  width: 350px;
  display: flex;
  flex-flow: column nowrap;
  align-items: stretch;
`;
const TextArea = styled_components_1.default.textarea `
  font-size: 14px;
  height: 10em;
  margin: 4px;
`;
const ExplainerText = styled_components_1.default.div `
  font-size: 13px;
`;
const TopicInfo = styled_components_1.default.div `
  font-style: italic;
  font-size: 14px;
  margin: 5px 12px;
`;
const ActionButton = styled_components_1.default.button `
  outline: none;
  border: 1px solid black;
  margin: 4px;
  padding: 4px;
  font-family: CatV, monospace;
  color: black;
  font-size: 13px;
  text-align: center;

  &:hover &:not(:disabled) {
    color: #fa00dd;
  }

  :disabled {
    color: #868686;
  }
`;
const MAX_CHARS = 250;
exports.ZoneInfo = (props) => {
    const [isEditing, setEditing] = react_1.useState(false);
    const [editText, setEditText] = react_1.useState(props.zoneTopic);
    const clickButton = () => {
        if (isEditing) {
            props.onEdit(editText);
            setEditing(false);
        }
        else {
            setEditing(true);
        }
    };
    const charsUsed = editText.length;
    const overLimit = charsUsed > MAX_CHARS;
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(Header, null, "Chat Corner"),
        isEditing ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ExplainerText, null, "Edit the topic for the area:"),
            react_1.default.createElement(TextArea, { value: editText, onChange: (e) => setEditText(e.target.value) }),
            react_1.default.createElement(ExplainerText, null,
                react_1.default.createElement("span", { style: { color: overLimit ? "red" : "grey" } },
                    "(",
                    overLimit ? "too long" : MAX_CHARS - charsUsed + " chars remaining",
                    ")")))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ExplainerText, null, "Join groups in this area with topics you're interested in, or start a new group and set the topic! The topic for this group is:"),
            react_1.default.createElement(TopicInfo, null, props.zoneTopic))),
        props.canEdit ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ActionButton, { onClick: (e) => {
                    e.preventDefault();
                    clickButton();
                }, disabled: overLimit }, isEditing ? "Save" : "Edit"))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ExplainerText, null,
                react_1.default.createElement("strong", null, "Walk into the area to join the voice chat or edit the group topic."))))));
};
//# sourceMappingURL=data:application/json;base64,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